import { Icon } from "@chakra-ui/react";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

function Approve() {
  return <Icon as={IoIosCheckmarkCircleOutline} boxSize={5} color="gray" />;
}

export default Approve;
